import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { APIURL } from "../config";
import Snackbar from './Snackbar';

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [buttonText, setButtonText] = useState("Submit");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
    const navigate = useNavigate();
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

    const forgotpasswordHandler = async () => {
        setEmailError("");
        setError("");
        setButtonText("Submitting...");
        setEnableSubmit(false);
        let isValid = true;

        if (!email) {
            setEmailError("Email is required.");
            isValid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setEmailError("Invalid email format.");
                isValid = false;
            }
        }

        if (!isValid) {
            setError("Please fill in all fields correctly.");
            setButtonText("Submit");
            setEnableSubmit(true);
            return;
        }
        try {
            const response = await axios.post(APIURL + '/forgot-password', {
                email: email
            });
            if (response.status === 200) {
                setMessage("Password reset link has been sent to your email.");
                setSnackbar({ open: true, message: "Password reset link has been sent to your email.", type: "success" });
                setButtonText("Email Sent!");
                return;
            } else if (response.status === 404) {
                setSnackbar({ open: true, message: "Email not found. Please check and try again.", type: "error" });
                setError("Email not found. Please check and try again.");
            } else {
                setSnackbar({ open: true, message: "An error occurred. Please try again.", type: "error" });
                setError("An error occurred. Please try again.");
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                setSnackbar({ open: true, message: "Email not found. Please check and try again.", type: "error" });
                setError("Email not found. Please check and try again.");
            } else if (err.response && err.response.status === 500) {
                setSnackbar({ open: true, message: "We were unable to send the reset email. Please try again in a few minutes.", type: "error" });
                setError("We were unable to send the reset email. Please try again in a few minutes.");
            } else {
                setSnackbar({ open: true, message: "An error occurred. Please try again.", type: "error" });
                setError("An error occurred. Please try again.");
            }
        }

        setButtonText("Submit");
        setEnableSubmit(true);
    };

    return (
        <div>
            <Snackbar
                message={snackbar.message}
                type={snackbar.type}
                open={snackbar.open}
                onClose={closeSnackbar}
            />
            <div className="loginsignup">
                <div className="loginsignup-container">
                    <h1>Forgot Password</h1>
                    <div className="loginsignup-fields">
                        <label>
                            Email Address
                            <br />
                            <input
                                type="email"
                                className="email"
                                placeholder="Enter your email address"
                                style={{ width: "100%", maxWidth: "540px", height: "45px" }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <span style={{ color: "red" }}>{emailError}</span>
                            <span style={{ color: "green" }}>{message}</span>
                        </label>
                    </div>
                    <br />
                    <button className={`submit-button ${!enableSubmit ? "btn-loading" : ""}`} onClick={forgotpasswordHandler} disabled={!enableSubmit}>
                        {!enableSubmit && <span className="btn-spinner"></span>}
                        {buttonText || "Submit"}
                    </button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <br />
                    <br />

                    <button
                        type="button"
                        style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
                        className="register"
                        onClick={() => navigate("/login")}
                    >
                        Already have an account? Login
                    </button>
                    <br />
                    <br />
                </div>
            </div >
        </div >
    )
}

export default ForgotPassword